export const leadCaptureEmailsKeys = {
  list: (campaignId: string) =>
    ['campaigns', campaignId, 'leadCaptureEmails', 'list'] as const
};
